import { defineMessages } from 'react-intl-next';
export var searchMessages = defineMessages({
  searchLabel: {
    id: 'linkDataSource.confluence-search.configmodal.searchLabel',
    description: 'Placeholder text for the search input box',
    defaultMessage: 'Enter keywords to find pages, attachments, and more'
  }
});